(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('ForgotPasswordController', ForgotPasswordInject);

  /** @ngInject */
  function ForgotPasswordInject($state, userActions, ForgotPasswordViewModel) {
    var vm = this;

    vm.password = new ForgotPasswordViewModel();

    vm.forgotPassword = function (form) {
      var email = form.email.$viewValue;
      var language = localStorage.getItem('language');
      userActions.forgotPassword(email, language).then(
        function () {
          $state.go('login');
        },
        function () {
          vm.password.hasErrors = true;
        }
      );
    };
  }
})();
